/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SetPassword/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromValidate from 'Data/validate.js'
import PasswordRules from './PasswordRules/index'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import VisibilityAction from './VisibilityAction/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function SetPassword({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Content/SetPassword",
  isInvalid,
  onChange,
  onSubmit
  
}) {
  let flow = fromFlow.useFlow()
let signupConfirmPasswordValueData = fromData.useDataValue({ viewPath,
context: 'signup_confirm',
path: 'password',
})
let signupConfirmPasswordIsValidData = fromData.useDataIsValid({ viewPath,
context: 'signup_confirm',
path: 'password',
validate: fromValidate.password,
required: true,
})
let signupConfirmPasswordChangeData = fromData.useDataChange({ viewPath,
context: 'signup_confirm',
path: 'password',
})
let signupConfirmPasswordSubmitData = fromData.useDataSubmit({ viewPath,
context: 'signup_confirm',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="signup_confirm.password"
 validate="/Data/validate.js password"
 required={true}
 invalid={!signupConfirmPasswordIsValidData}
 value={signupConfirmPasswordValueData}
 onChange={signupConfirmPasswordChangeData}
 onSubmit={signupConfirmPasswordSubmitData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Set your password"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<React.Fragment>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type={flow.has(fromFlow.normalizePath(viewPath, 'VisibilityAction/Show')) ? "text" : "password"}
 placeholder="Set your password..."
/>
<VisibilityAction
{...childProps}
  viewPath={`${viewPath}/VisibilityAction`}
/>
</React.Fragment>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
<PasswordRules
  viewPath={`${viewPath}/PasswordRules`}
/>
{children}
</React.Fragment>)
}